<template>
    <div class="users container">
        <form @submit.prevent="onSubmit">
            <div class="columns is-centered">
                <div class="column is-one-third">
                    <div class="card-container">
                        <h1 class="title">Invite Admin Account</h1>
                        <b-field label="Email">
                            <b-input type="text" name="userEmail" v-model="email" required/>
                        </b-field>
                        <div class="columns columns-button is-mobile is-multiline" >
                            <div class="column column-button-right">
                                <router-link class="button is-danger is-outlined is-fullwidth" :to="{name: 'adminAccountManagement'}">Cancel</router-link>
                            </div>
                            <div class="column column-button-right">
                                <button class="button is-success is-fullwidth">submit</button>
                                <p class="help-text">An email will be sent out with log in instructions.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import userAPI from '@/api/UserAPI.js'
import sharedAPI from '@/api/SharedAPI.js'
import store from '../store.js'


import { mapGetters } from 'vuex'
import { mapState, mapMutations } from 'vuex'

export default {
    name: 'NewAdminAccountForm',

    data(){
        return {
            email: null,
            errorMsg: null,
            notificationDuration: 4000,  
        }
    },

    computed: {
      ...mapState([
        'userInfo',
      ])
    },

    methods: {

      /**
       * RUN FILEMAKER SCRIPT TO CREATE THE NEW ADMIN ACCOUNT.
       */
      onSubmit: async function(){
        if(this.email == null){
          this.$snotify.error("Email must be filled in.", "Error",
            {
              showProgressBar: false,
              position: 'rightBottom',
              icon: false,
              timeout: this.notificationDuration,
              closeOnClick: true,
              bodyMaxLength: 1000
            }
          )
          return
        }

        var params = `{
          "username": "${this.email}",
          "userEmail": "${this.email}",
          "accountID": "${this.userInfo.accountID}"
        }`;

        console.log(params)

        try{
          const result = await sharedAPI.runScript("User - Invite Admin Account", params);
          var scriptResult = JSON.parse(result.response.scriptResult);
          var errorCode = scriptResult.messages.code;
          
          if(errorCode != 0){
            throw scriptResult.messages;
          }

          this.$snotify.success(`Admin Account successfully created`, "Success",
          {
            showProgressBar: false,
            position: 'rightBottom',
            icon: false,
            timeout: this.notificationDuration,
            closeOnClick: true,
            bodyMaxLength: 1000
          }
        )

        this.$router.replace({ name: 'adminAccountManagement' });
        }
        catch(e){
          if(e.message){
            this.$snotify.error(e.message, "Error",
              {
                showProgressBar: false,
                position: 'rightBottom',
                icon: false,
                timeout: this.notificationDuration,
                closeOnClick: true,
                bodyMaxLength: 1000
              }
            )
          }
          else if(e.response.messages[0].message != undefined){
            this.$snotify.error(e.message[0].message, "Error",
              {
                showProgressBar: false,
                position: 'rightBottom',
                icon: false,
                timeout: this.notificationDuration,
                closeOnClick: true,
                bodyMaxLength: 1000
              }
            )
          }
          else{
            this.$snotify.error("Could not create the admin account.", "Error",
              {
                showProgressBar: false,
                position: 'rightBottom',
                icon: false,
                timeout: this.notificationDuration,
                closeOnClick: true,
                bodyMaxLength: 1000
              }
            )
          }
        }

      }
    }
}
</script>

<style scoped>
  .button.is-danger{
    margin-bottom: 20px;
  }
  .button.is-outlined{
    border-color: #7F1E27;
    color: #7F1E27;
  }
  .button.is-outlined:hover{
    border-color: #7F1E27;
    background-color: #7F1E27;
    color: #ffffff;
  }
  input{
    margin-bottom: 15px;
  }
  .is-danger{
    margin-right: 10px;
  }
  .card-container {
    padding: 2rem;
    margin: 0px 20px 20px 20px;
  }  
  .page-title{
    margin: 0px 10px 0px 10px;
  }
  .columns-button{
     margin: 0px;
  }
  .column-button-left{
    padding: 0px;
  }
  .column-button-right{
    padding: 0px;
    flex: none;
  }
  .help-text{
    font-size: .75rem;
    color: #333333;
    font-style: italic;
  }

  
@media only screen and (min-width: 300px) {
  .columns-button{
     margin-top: 30px;
  }
  .column-button-left{
    padding: 0px;
    width: 100%;
  }
  .column-button-right{
    padding: 0px;
    width: 100%;
  }
  .button.is-primary{
    margin-top: 10px;
    width: 100%;
    font-style: italic;
  }
}
</style>